import { IGlobalState } from '../../../Root/store/appReducer'
import { deriveGroupOptions } from '../../MyGroups/helpers/groupOptions'
import { getUserGoals } from '../../Activity/store/ActivitySelectors'
import { userCompaniesSelector, companyDivisionsSelector } from '../../Settings/store/SettingsSelectors'

// The || coercions cover rehydrated persisted state from before these fields existed.
export const getChatListFilter = (state: IGlobalState) => state.chat?.chatListFilter || null
export const getChatUnreadCount = (state: IGlobalState) => state.chat?.unreadCount || 0
export const getChatChannelMeta = (state: IGlobalState) => state.chat?.channelMeta || {}

// Stream cids of every channel the chat view can show: participating chat-enabled challenges
// plus the user's groups. Used to scope the unread badge — the raw Stream total also counts
// channels outside the app (ended/left chats, other environments on the shared Stream app).
// The 'challenge'/'group' literals mirror channelType/groupChannelType (kept inline to avoid
// pulling the chat hook modules into this selector).
export const getRelevantChatCids = (state: IGlobalState): string[] => {
  const challengeCids = (getUserGoals(state) || [])
    .filter((goal) => goal.participating && goal.chatEnabled)
    .map((goal) => `challenge:${goal.id}`)
  const groupCids = deriveGroupOptions(userCompaniesSelector(state), companyDivisionsSelector(state))
    .filter((option) => !!option.divisionId)
    .map((option) => `group:${option.divisionId}`)
  return [...challengeCids, ...groupCids]
}
